import React from 'react'

const site = JSON.parse(localStorage.getItem('site'))
const acc = JSON.parse(localStorage.getItem('acc'))

import { ReactComponent as HeaderCatalog } from '../assets/svg/Header/HeaderCatalog.svg'
import { ReactComponent as OperationShopping } from '../assets/svg/Header/OperationShopping.svg'
import { ReactComponent as OperationPartnership } from '../assets/svg/Header/OperationPartnership.svg'
import { ReactComponent as OperationPicking } from '../assets/svg/Header/OperationPicking.svg'
import { ReactComponent as OperationStock } from '../assets/svg/Header/OperationStock.svg'
import { ReactComponent as OperationCheckList } from '../assets/svg/Header/OperationCheckList.svg'
import { ReactComponent as OperationStatistic } from '../assets/svg/Header/OperationStatistic.svg'
import { ReactComponent as OperationShipmentPartners } from '../assets/svg/Header/OperationShipmentPartners.svg'
import { ReactComponent as OperationSPO } from '../assets/svg/Header/OperationSPO.svg'
import { ReactComponent as OperationBuyer } from '../assets/svg/Header/OperationBuyer.svg'
import { ReactComponent as OperationLowAnalyzer } from '../assets/svg/Header/OperationLowAnalyzer.svg'
import { ReactComponent as OperationOrderHistory } from '../assets/svg/Header/OperationOrderHistory.svg'
import { ReactComponent as OperationProductsManager } from '../assets/svg/Header/OperationProductsManager.svg'
import { ReactComponent as OperationSalesForCom } from '../assets/svg/Header/OperationSalesForCom.svg'
import { ReactComponent as OperationCheckList1MKR } from '../assets/svg/Header/OperationCheckList.svg'
import { ReactComponent as OperationDebtors } from '../assets/svg/Header/OperationDebtors.svg'

export const catalog = [
  {
    permission: site?.avalible?.operations?.shopping,
    link: '/admin/catalog',
    name: `Catalog `,
    icon: <HeaderCatalog width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: false,
  },
  {
    permission: site?.avalible?.operations?.shopping,
    link: '/admin/catalogCompare',
    name: 'Price Analyzer',
    icon: (
      <OperationCheckList1MKR
        width={'30px'}
        height={'30px'}
      />
    ),
    enabled: true,
    disabled: false,
  },
  {
    permission: site?.avalible?.operations?.facturas,
    link: '/admin/productsManager',
    name: 'Products Manager',
    icon: (
      <OperationProductsManager
        width={'30px'}
        height={'30px'}
      />
    ),
    enabled: true,
    disabled: false,
  },
  // {
  //   permission: site?.avalible?.operations?.facturas,
  //   link: '/admin/productsManager/history',
  //   name: 'Factura History',
  //   icon: (
  //     <OperationDebtors width={'30px'} height={'30px'} />
  //   ),
  //   enabled: true,
  //   disabled: false,
  // },
  {
    permission: site?.avalible?.operations?.shopping,
    link: '/admin/lowAnalyzer',
    name: 'Low profits',
    icon: (
      <OperationLowAnalyzer
        width={'30px'}
        height={'30px'}
      />
    ),
    enabled: true,
    disabled: false,
  },
  {
    permission: site?.avalible?.operations?.facturas,
    link: '/admin/salesForCom',
    name: 'SPO Management',
    icon: (
      <OperationSalesForCom
        width={'30px'}
        height={'30px'}
      />
    ),
    enabled: true,
    disabled: false,
  },
  {
    permission: site?.avalible?.operations?.facturas,
    link: '/admin/SPO',
    name: 'Personal Rates',
    icon: (
      <OperationShipmentPartners
        width={'30px'}
        height={'30px'}
      />
    ),
    enabled: localStorage.getItem('name') === 'TPO',
    disabled: false,
  },
]
